/**
 * Builds URLs for doctor assessment / stim HTML forms under public/user-forms.
 */
const ASSESSMENT_FORM_PATHS = {
  EXTENDED_ASSESSMENT: {
    current: "extended-assessment.html",
    migrated: "migrated/extended-assessment.html",
  },
  GENERAL_ASSESSMENT: {
    current: "general-assessment.html",
    migrated: "migrated/general-assessment.html",
  },
  BASIC_ASSESSMENT: {
    current: "basic-assessment.html",
    migrated: "migrated/basic-assessment.html",
  },
  QEEG_ASSESSMENT: { current: "qeeg-assessment.html" },
  EXTENDED_STIM: {
    current: "extended-stim.html",
    migrated: "migrated/extended-stim.html",
  },
  GENERAL_STIM: { current: "general-stim.html" },
  BASIC_STIM: { current: "basic-stim.html" },
  VIRTUAL_STIM: { current: "virtual-stim.html" },
  QEEG_STIM: { current: "qeeg-stim.html" },
  LENS_NFB_ASSESSMENT: { current: "lens-nfb-assessment.html" },
};

export function getDoctorAssessmentFormPath(formTypeEnum, isMigrated = false) {
  const entry = ASSESSMENT_FORM_PATHS[formTypeEnum];
  if (!entry) {
    return null;
  }
  if (isMigrated && entry.migrated) {
    return entry.migrated;
  }
  return entry.current;
}

export function getDoctorAssessmentFormUrl({
  formTypeEnum,
  hospitalId,
  patientId,
  assessmentFormId,
  isMigrated = false,
  viewMode = "read",
  downloadPdf = false,
  patientView = false,
}) {
  const path = getDoctorAssessmentFormPath(formTypeEnum, isMigrated);
  if (!path) {
    return null;
  }

  const params = new URLSearchParams({
    patientID: String(patientId),
    assessmentFormID: String(assessmentFormId),
    viewMode,
  });

  if (!patientView && hospitalId) {
    params.set("hospitalID", String(hospitalId));
  }
  if (downloadPdf) {
    params.set("downloadPdf", "1");
  }

  return `user-forms/doctor-assessment/${path}?${params.toString()}`;
}

export function openDoctorAssessmentForm(options) {
  const url = getDoctorAssessmentFormUrl(options);
  if (!url) {
    alert("Invalid assessment form type");
    return;
  }
  window.open(url, "_blank");
}
